import { useRef } from "react";

/**
 * returns true on mount (first render) false otherwise
 * @returns {Boolean} true on mount (first render) false otherwise
 */
function useIsMount() {
  const isMount = useRef(true);
  if (isMount.current) {
    isMount.current = false;
    return true;
  }
  return isMount.current;
}

export default useIsMount;
